/** Formatter-Helpers für deutsches Datum/Geld. */

import { format } from "date-fns";
import { de } from "date-fns/locale";

export function formatDate(iso: string | Date, pattern = "EEE, dd.MM.yyyy"): string {
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return format(d, pattern, { locale: de });
}

export function formatTime(iso: string | Date): string {
  const d = typeof iso === "string" ? new Date(iso) : iso;
  return format(d, "HH:mm", { locale: de });
}

export function formatRange(startIso: string, endIso: string): string {
  const s = new Date(startIso);
  const e = new Date(endIso);
  const sameDay = s.toDateString() === e.toDateString();
  return sameDay
    ? `${formatDate(s)} · ${formatTime(s)} – ${formatTime(e)}`
    : `${formatDate(s)} ${formatTime(s)} – ${formatDate(e)} ${formatTime(e)}`;
}

export function formatPriceEur(value: string | number): string {
  const num = typeof value === "string" ? Number.parseFloat(value) : value;
  return new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
  }).format(num);
}
